import { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Form, Button, Image, Modal } from "react-bootstrap";
import { FaUser, FaCamera } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CameraComponent from "../../../shared/components/CameraComponent";
import { getFormattedDate } from '../../../shared/utils/getFormattedDate';
import Swal from "sweetalert2";
import { useProfile } from "../hooks/useProfile";
import { useAuth } from "../../auth/hooks/useAuth";

const ProfileSection = ({
    profile,
    addProfile,
    editProfile,
    data,
    response }) => {

    // const { fetchProfile, profile } = useProfile();
    const { auth, validate } = useAuth();

    const [showOptions, setShowOptions] = useState(false);
    const [showCamera, setShowCamera] = useState(false);

    const handleOptionsOpen = () => setShowOptions(true);
    const handleOptionsClose = () => setShowOptions(false);

    const navigate = useNavigate();

    const handleOpenCamera = () => {
        setShowOptions(false);
        setShowCamera(true);
    };

    const handleImage = (image) => {
        const setDataProfile = {
            image_profile: image,
            name: profile[0]?.full_name,
            username: auth?.username,
            phone: profileData.phone ? profileData.phone : profile[0]?.phone,
            gender: profileData.gender ? profileData.gender : profile[0]?.gender,
            birthday: profileData.birthday ? profileData.birthday : profile[0]?.birthday,
        }

        if (profile[0]?.id) {
            editProfile(profile[0]?.id, setDataProfile);
            setProfileData({
                image_profile: "",
                birthday: "",
                gender: "",
                name: "",
                phone: "",
                username: ""
            })
        } else {
            addProfile(setDataProfile)
            setProfileData({
                image_profile: "",
                birthday: "",
                gender: "",
                name: "",
                phone: "",
                username: ""
            })
        }
    }

    const isModified = useRef(false);

    const handleChange = (e) => {

        isModified.current = true;
        const { name, value } = e.target;
        let newValue = value;

        if (name === "phone") {
            newValue = value.replace(/[^0-9]/g, '');
        }

        setProfileData((prevData) => ({
            ...prevData,
            [name]: newValue,
        }));
    };

    const [profileData, setProfileData] = useState(() => ({
        image_profile: profile[0]?.image_profile || "",
        name: profile[0]?.full_name || "",
        username: auth?.username || "",
        phone: profile[0]?.phone || "",
        gender: profile[0]?.gender
            ? profile[0].gender.charAt(0).toUpperCase() + profile[0].gender.slice(1).toLowerCase()
            : "",
        birthday: profile[0]?.birthday ? getFormattedDate(profile[0].birthday) : "",
    }));

    useEffect(() => {
        // if (profile) {
        //     setProfileData({
        //         phone: profile?.phone ?? "",
        //         gender: profile?.gender ?? "",
        //         birthday: profile?.birthday
        //             ? getFormattedDate(profile?.birthday)
        //             : "",
        //     });
        // }
        // fetchProfile();
        // validate();
    }, [
        // fetchProfile,
        validate
    ]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const setDataProfile = {
            image_profile: profileData?.image_profile,
            name: profile[0]?.full_name,
            username: profile[0]?.username,
            phone: parseInt(profileData.phone),
            gender: profileData.gender,
            birthday: profileData.birthday,
        }

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit the form?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
        });

        if (result.isConfirmed) {
            if (profile[0]?.id) {
                editProfile(profile[0]?.id, setDataProfile)
            } else {
                addProfile(setDataProfile)
            }
            Swal.fire("Submitted!", "Your form has been submitted.", "success");
        }

    }

    return (
        <>
            <Row style={{
                borderTopLeftRadius: '2rem',
                borderTopRightRadius: '2rem'
            }}>
                {/* Sidebar Navigation */}
                <Col md={3}>
                    <Card className="p-3" style={{}}>
                        <h5>My Account</h5>
                        <ul className="list-unstyled">
                            <li className="py-2 fw-bold" style={{ color: '#d9534f', cursor: 'pointer' }} onClick={() => navigate('/profile')}>Profile</li>
                            <li className="py-2 text-muted" style={{ cursor: 'pointer' }} onClick={() => navigate('/cart')}>Cart</li>
                            <li className="py-2 text-muted" style={{ cursor: 'pointer' }} onClick={() => navigate('/history-transaction')}>History Transactions</li>
                            {/* <li className="py-2 text-muted" onClick={() => navigate('/cart')}>T</li>
                            <li className="py-2 text-muted">Settings</li> */}
                        </ul>
                    </Card>
                </Col>

                {/* Profile Form */}
                <Col md={9}>
                    <Card className="p-4" style={{}}>
                        <Row>
                            {/* Profile Picture */}
                            <Col md={3} className="text-center">
                                <div className="position-relative">
                                    <Image
                                        src={profile[0]?.image_profile ? profile[0]?.image_profile : 'icons8-man-48.png'}
                                        alt="Profile"
                                        className="rounded-circle border"
                                        width="100"
                                        height="100"
                                        name="image_profile"
                                    />
                                    <Button
                                        variant="light"
                                        className="position-absolute bottom-0 end-0 p-1"
                                        onClick={handleOptionsOpen}>
                                        <FaCamera />
                                    </Button>
                                </div>
                            </Col>


                            {/* Modal for selecting between camera and file manager */}
                            <Modal show={showOptions} onHide={handleOptionsClose} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Select Option</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="text-center">
                                    {/* Option to open the custom camera preview */}
                                    <Button variant="primary" className="m-2" onClick={handleOpenCamera}>
                                        Open Camera
                                    </Button>

                                    {/* Option to open the file manager */}
                                    <label className="btn btn-secondary m-2">
                                        Open File Manager
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className="d-none"
                                            onChange={(e) =>
                                                console.log("File selected:", e.target.files)
                                            }
                                        />
                                    </label>
                                </Modal.Body>
                            </Modal>

                            {/* Modal containing the CameraComponent */}
                            <Modal show={showCamera} onHide={() => setShowCamera(false)} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Camera Preview</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <CameraComponent hide={() => setShowCamera(false)} image={handleImage} />
                                </Modal.Body>
                            </Modal>

                            {/* Profile Details Form */}
                            <Col md={9}>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ fontSize: 15 }}>Name :</Form.Label><Form.Label style={{ fontSize: 15 }}>&nbsp;{auth?.full_name}</Form.Label>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ fontSize: 15 }}>Username :</Form.Label><Form.Label style={{ fontSize: 15 }}>&nbsp;{auth?.username}</Form.Label>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ fontSize: 15 }}>Your Number Phone :</Form.Label><Form.Label style={{ fontSize: 15 }}>&nbsp;{profile[0]?.phone}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="phone"
                                            value={profileData.phone ?? ""}
                                            inputMode="numeric"
                                            pattern="^[0-9]*$"
                                            onChange={handleChange}
                                            placeholder="Change your number phone"
                                            style={{ background: 'transparent' }}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ fontSize: 13 }}>Gender :</Form.Label><Form.Label style={{ fontSize: 15 }}>&nbsp;{profile[0]?.gender}</Form.Label>
                                        <Form.Select
                                            name="gender"
                                            value={profileData?.gender ?? ""}
                                            onChange={handleChange}
                                            style={{ background: 'transparent' }}>
                                            <option value=""
                                                placeholder="Change your gender">- Jenis Kelamin -</option>
                                            <option style={{ background: 'transparent' }} value="Male">Male</option>
                                            <option style={{ background: 'transparent' }} value="Female">Female</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Birthday :</Form.Label><Form.Label style={{ fontSize: 15 }}>&nbsp;{profile[0]?.birthday}</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="birthday"
                                            value={profileData.birthday}
                                            onChange={handleChange}
                                            style={{ background: 'transparent' }}
                                        />
                                    </Form.Group>

                                    <Button
                                        style={{
                                            background: '#d9534f',
                                            border: '2px solid #b52b27', // Border color
                                            color: 'white',
                                            padding: '10px 20px',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => e.target.style.background = '#c9302c'} // Hover effect
                                        onMouseLeave={(e) => e.target.style.background = '#d9534f'}
                                        onClick={handleSubmit}>Simpan
                                    </Button>

                                </Form>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default ProfileSection;
